import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
// @material-ui/icons
// core components
import MyHeader from 'components/Header/MyHeader.js'
import MyFooter from 'components/Footer/MyFooter.js'
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import Parallax from 'components/Parallax/Parallax.js'
// sections for this page
import MyHeaderLinks from 'components/Header/MyHeaderLinks.js'

import ConsultSection from './Sections/ConsultSection.js'
import DesignSection from './Sections/DesignSection.js'
import TestSection from './Sections/TestSection.js'

import styles from 'assets/jss/material-kit-react/views/servicePage.js'

const useStyles = makeStyles(styles)

export default function ServicePage(props) {
  const classes = useStyles()
  const { ...rest } = props
  return (
    <div>
      <MyHeader color="white" brand="江苏硕佰建筑科技有限公司" fixed rightLinks={<MyHeaderLinks />} {...rest} />
      <Parallax small image={require('assets/img/companyPage/nanjing.jpg')}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem>
              <div className={classes.brand}>
                <h1 className={classes.title}>服务类型</h1>
                <h4>公司业务主要包含三个板块，分为别为咨询板块、设计板块和检测板块</h4>
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <ConsultSection />
          <DesignSection />
          <TestSection />
        </div>
      </div>
      <MyFooter />
    </div>
  )
}
